export const getCurrentRoute = () => {
  return window.location.pathname + window.location.search;
};
